var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapboxPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15.142,
    viewBox: "0 0 10 15.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M5,15.142H5a34.2,34.2,0,0,1-2.5-3.43C1.36,9.92,0,7.353,0,5.3A5.431,5.431,0,0,1,1.463,1.551a4.807,4.807,0,0,1,7.073,0A5.431,5.431,0,0,1,10,5.3c0,2.053-1.36,4.62-2.5,6.412A34.2,34.2,0,0,1,5,15.142ZM5,3.407A1.844,1.844,0,0,0,3.214,5.3,1.844,1.844,0,0,0,5,7.193,1.844,1.844,0,0,0,6.786,5.3,1.844,1.844,0,0,0,5,3.407Z",
    fill: "#0f3557"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapboxPin);
export default __webpack_public_path__ + "static/media/mapbox_pin.a979a81d89cf72710f956ba8e3c13532.svg";
export { ForwardRef as ReactComponent };